/** Keep in sync with functions/lib/selfPhoneBatches.ts */
export const SELF_PHONE_BATCH_COUNT = 5;

export const SELF_PHONE_BATCHES = [
  { number: 1, shipLabel: 'September 1, 2026' },
  { number: 2, shipLabel: 'September 30, 2026' },
  { number: 3, shipLabel: 'October 17, 2026' },
  { number: 4, shipLabel: 'January 17, 2027' },
  { number: 5, shipLabel: 'March 30, 2027' },
] as const;

export type BatchStatus = 'complete' | 'open' | 'upcoming';

export type PhoneBatch = {
  number: number;
  shipLabel: string;
  size: number;
  sold: number;
  remaining: number;
  status: BatchStatus;
};

export type PhoneBatchState = {
  currentBatch: number | null;
  currentBatchShipLabel: string | null;
  currentBatchRemaining: number;
  currentBatchSize: number;
  currentBatchSold: number;
  nextOrderBatch: number | null;
  nextOrderShipLabel: string | null;
  batches: PhoneBatch[];
};

export function computeBatchState(
  sold: number,
  totalUnits: number,
  batchCount = SELF_PHONE_BATCH_COUNT
): PhoneBatchState {
  const batchSize = Math.floor(totalUnits / batchCount);
  const batches: PhoneBatch[] = SELF_PHONE_BATCHES.map((batch, index) => {
    const start = index * batchSize;
    const end = start + batchSize;

    if (sold >= end) {
      return {
        number: batch.number,
        shipLabel: batch.shipLabel,
        size: batchSize,
        sold: batchSize,
        remaining: 0,
        status: 'complete',
      };
    }

    if (sold >= start) {
      const soldInBatch = sold - start;
      return {
        number: batch.number,
        shipLabel: batch.shipLabel,
        size: batchSize,
        sold: soldInBatch,
        remaining: batchSize - soldInBatch,
        status: 'open',
      };
    }

    return {
      number: batch.number,
      shipLabel: batch.shipLabel,
      size: batchSize,
      sold: 0,
      remaining: batchSize,
      status: 'upcoming',
    };
  });

  const openBatch = batches.find((b) => b.status === 'open');

  if (!openBatch || sold >= totalUnits) {
    return {
      currentBatch: null,
      currentBatchShipLabel: null,
      currentBatchRemaining: 0,
      currentBatchSize: batchSize,
      currentBatchSold: 0,
      nextOrderBatch: null,
      nextOrderShipLabel: null,
      batches,
    };
  }

  return {
    currentBatch: openBatch.number,
    currentBatchShipLabel: openBatch.shipLabel,
    currentBatchRemaining: openBatch.remaining,
    currentBatchSize: openBatch.size,
    currentBatchSold: openBatch.sold,
    nextOrderBatch: openBatch.number,
    nextOrderShipLabel: openBatch.shipLabel,
    batches,
  };
}
